export const KeyCodes = { Ro: 32, yo: 9, Oo: 13, _h: 27 };
